/* eslint-disable  */
import { Component } from 'react';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { Control, actions, Errors } from 'forms/rrf';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class TextInput extends Component {
  static TEXT = 'text';
  static TEXTAREA = 'textarea';

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  handleChange = (event) => {
    const { pattern, model, dispatch } = this.props;
    const { value } = event.target;

    dispatch(actions.setValidity(model, {pattern: true}));
    dispatch(actions.setErrors(model, {pattern: false}));

    if (pattern !== undefined) {
      const valueArray = value.trim().replace('\r', '').split('\n');
      
      valueArray.forEach(v => {
        if (!pattern.test(v)) {
          dispatch(actions.setValidity(model, {pattern: false}));
          dispatch(actions.setErrors(model, {pattern: true}));
        }
      });
    }
  };

  onBlur = () => {
    const { onBlur } = this.props;

    if (typeof onBlur === 'function') {
      onBlur();
    }
  }

  render() {
    const {
      label, model, placeholder, controlId, groupClassName, type, ...rest
    } = this.props;
    const InputElement = Control[type];
    const additionalProps = {
      [TextInput.TEXTAREA]: {
        as: TextInput.TEXTAREA
      },
      [TextInput.TEXT]: {},
    };

    return (
      <FormGroup className={`form-group ${groupClassName || ''}`} controlId={`text-input-${controlId}`}>
        {label && (<div>
          <FormLabel>
            {label}
          </FormLabel>
        </div>)}
        <InputElement
          onBlur={this.onBlur}
          onChange={this.handleChange}
          component={FormControl}
          model={model}
          placeholder={placeholder || label}
          {...rest}
          {...additionalProps[type]}
        />
        <Errors
          className="errors"
          model={model}
          messages={
            {
              pattern: 'The input is invalid. Please, follow the instructions',
              isUrl: 'Must be a valid url starting http:// or https://'
            }
          }
          show
        />
      </FormGroup>
    );
  }
}

TextInput.propTypes = {
  placeholder: PropTypes.string,
  controlId: PropTypes.string,
  label: PropTypes.string,
  pattern: PropTypes.object,
  groupClassName: PropTypes.string,
  model: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    TextInput.TEXT,
    TextInput.TEXTAREA,
  ]),
};

TextInput.defaultProps = {
  type: TextInput.TEXT,
  placeholder: '',
  groupClassName: '',
  label: null,
  controlId: Math.random()
    .toString(16)
    .substring(2),
};

export default connect()(TextInput);
